import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const GuestGuard = ({ children }) => {
  const searchParams = new URLSearchParams(document.location.search);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const callbackURL = searchParams.get("callbackURL");
  const type = searchParams.get("type");
  const location = useLocation();

  if (isAuthenticated) {
    if (location && (
      location?.pathname?.includes("/auth/lti/desktop") ||
      location?.pathname?.includes("/auth/lti/vm")
    )) {
      return children;
    }

    // if (callbackURL && callbackURL !== "/" && callbackURL.indexOf("?state=") === -1) {
    //   return <Navigate to={`/${type ? "?type=demo" : ""}`} />;
    // }

    return <Navigate to={`/${type ? "?type=demo" : ""}`} />;
  }

  return <>{children}</>;
};

export default GuestGuard;
